/**
 * DTO para criar código de cadastro
 * Enviado para POST /api/v1/clients/authenticate/createReceiveCode
 */
export interface CreateSignupCodeDto {
	name: string
	phone: string
	email: string
	cpf: string
	bin: number
}

/**
 * Resposta da API ao criar código de cadastro
 */
export interface CreateSignupCodeResponse {
	clientId: string
	email: string
}

// ------------------------------------------------------------------------------------------------

/**
 * DTO para reenviar código de cadastro
 */
export interface ResendSignupCodeDto {
	clientId: string
	type?: 'email' | 'sms'
}

/**
 * Resposta da API ao reenviar código de cadastro
 */
export interface ResendSignupCodeResponse {
	success: boolean
}

// ------------------------------------------------------------------------------------------------

/**
 * DTO para confirmar código de cadastro
 */
export interface ConfirmSignupCodeDto {
	clientId: string
	registrationCode: string
}

/**
 * Resposta da API ao confirmar código de cadastro
 */
export interface ConfirmSignupCodeResponse {
	tokens: {
		accessToken: string
		refreshToken: string
	}
}

// ------------------------------------------------------------------------------------------------

/**
 * DTO para login
 */
export interface LoginDto {
	cpf: string
}

/**
 * Resposta da API ao login
 */
export interface LoginResponse {
	clientId: string
	email: string
}
